export const version = '2.49.1';
//# sourceMappingURL=version.js.map